<script>
import { JitsiMeet } from "@mycure/vue-jitsi-meet";
import videoRoomService from "@/services/videoRoom";

export default {
  name: "Jitsi",

  props: {
    patientId: {
      type: String,
      require: true,
    },
    appointmentId: {
      type: String,
    },
  },

  components: {
    JitsiMeet,
  },

  data() {
    return {
      roomId: undefined,
      isLoading: false,
      isAudioEnabled: true,
      isVideoEnabled: true,
      isConnecting: false,
    };
  },

  computed: {
    jitsiOptions() {
      return {
        roomName: this.roomId,
        noSSL: false,
        // configOverwrite: {
        //   enableNoisyMicDetection: false,
        // },
        // interfaceConfigOverwrite: {
        //   SHOW_JITSI_WATERMARK: false,
        //   SHOW_WATERMARK_FOR_GUESTS: false,
        //   SHOW_CHROME_EXTENSION_BANNER: false,
        // },
        onload: this.onIFrameLoad,
      };
    },
  },

  methods: {
    onIFrameLoad() {
      // do stuff
    },

    async createRoom() {
      try {
        this.isConnecting = true;
        const { roomId } = await videoRoomService.createRoom({
          patientId: this.patientId,
          appointmentId: this.appointmentId,
        });
        this.roomId = roomId;
        this.isConnecting = false;
      } catch (err) {
        console.log(err);
        this.isConnecting = false;
      }
    },
  },
};
</script>

<template lang="pug">
.video-chat
  .status-screen(v-if="!roomId")
    h2 ¿Todo listo para unirte?
    button.button.button--blue(@click="createRoom") {{isConnecting ? 'Conectando...' : "Unirse"}}
  JitsiMeet(
    v-else
    domain="jitsi.quantuxdigital.com"
    :options="jitsiOptions"
  )
</template>

<style lang="scss">
.video-chat {
  height: 500px;
  background-color: black;
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;

  .status-screen {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.3);
    color: white;

    h2 {
      color: white;
      margin-bottom: 10px;
    }

    .button {
      -webkit-box-shadow: -3px 5px 15px 5px rgba(0, 0, 0, 0.29);
      box-shadow: -3px 5px 15px 5px rgba(0, 0, 0, 0.29);
      border-radius: 10px;
      font-size: 16px;
      padding: 20px;
      margin: 0 auto;
    }
  }

  .status-track {
    position: absolute;
    top: 15px;
    left: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    color: white;
    font-size: 22px;
  }

  #remoteTrack {
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.3);

    h2 {
      color: white;
      margin-bottom: 10px;
    }

    .track-container {
      width: 100%;
      height: 100%;
      text-align: center;
      display: flex;
      justify-content: center;

      .audio-off-container {
        position: absolute;
        left: 10px;
        top: 10px;

        .audio-off {
          fill: white;
          height: 25px;
          width: 25px;
        }
      }

      .video-off-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .video-off {
          fill: white;
          height: 52px;
          width: 52px;
        }

        h4 {
          color: white;
          font-size: 22px;
          font-weight: 600;
        }
      }

      video {
        border-radius: 5px;
      }
    }
  }

  #localTrack {
    position: absolute;
    z-index: 3;
    width: 25vw;
    height: 15vh;
    right: 10px;
    bottom: 10px;

    .track-container {
      text-align: right;
      width: 100%;
      height: 100%;

      video {
        -webkit-box-shadow: -3px 5px 15px 5px rgba(0, 0, 0, 0.29);
        box-shadow: -3px 5px 15px 5px rgba(0, 0, 0, 0.29);
        border-radius: 5px;
      }
    }
  }

  .video-controls {
    position: absolute;
    z-index: 3;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%);
    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 20px;

    .toggle__button {
      background-color: rgba(224, 224, 224, 0.3);
      border: none;
      border-radius: 50%;
    }

    .toggle__button:hover {
      opacity: 0.8;
    }

    .button_phone,
    .button_mic_off,
    .button_camera_off {
      background-color: rgb(234, 67, 53);
      border: none;

      svg {
        fill: white;
        color: white;
      }
    }

    .button_mic,
    .button_camera {
      svg {
        fill: white;
        color: white;
      }
    }
  }
}
</style>
